import React, { useEffect, useState } from 'react'
import {
  Button,
  Stack,
  TextField,
  Box,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material'
import { useParams } from 'react-router-dom'
import { ApiCreateScenario, ApiCreateStaffManager, ApiDeleteScenario, ApiDeleteStaffManager, ApiGetScenario, ApiGetStaffManager, ApiUpdateScenario, ApiUpdateStaffManager } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import edit from '../Template Listing/editicon.png';
import deleteicon from '../Template Listing/deleteicon.png'

const StoreScenarios: React.FC = () => {
  const [Scenarios, setScenarios] = useState<any>([])
  const adminId: any = localStorage.getItem('userId')
  const [scenarioName, setscenarioName] = useState("")
  const [selectedScenario, setselectedScenario] = useState<any>()
  const [open, setOpen] = useState(false)
  const { id } = useParams()

  const getScenarioList = async () => {
    try {
      const data = `?offset=0&limit=100&clientEntityId=${id}`
      const res = await ApiGetScenario(data)
      if (res?.data) {
        setScenarios(res?.data || [])
      }
    } catch (error: any) {
      toast.error("Error", error?.message)
    }
  }


  const ScenarioStaff = async () => {
    if (scenarioName?.trim().length < 1) {
      window.alert("Please add Manager Name");
      return;
    }

    try {
      const data = {
        scenarioName: scenarioName?.trim(),
        clientEntityId: id,
        ...(selectedScenario
          ? {
            modifiedBy: adminId,
            scenarioId: selectedScenario?.scenarioId,
          }
          : {
            createdBy: adminId,
          }),
      };

      const res = selectedScenario
        ? await ApiUpdateScenario(data)
        : await ApiCreateScenario(data);

      if (res?.data) {
        setScenarios(res?.data);
        setscenarioName("");
        setOpen(false);
        setselectedScenario(null);
        getScenarioList()
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    }
  };


  useEffect(() => {
    getScenarioList()
  }, [])

  const handleDeleteStaff = async (scenarioId: number) => {
    const isConfirm = window.confirm("Are you sure you want to delete this scenario?")
    if (isConfirm) {
      try {
        const data = `?scenarioId=${scenarioId}`
        const res = await ApiDeleteScenario(data)
        if(res?.success || res?.status){
          getScenarioList()
        }
      } catch (error: any) {
        toast.error("Error", error?.message)
      }
    }
  }


  return (
    <div className='w-100 p-2'>
      <Box className='bg-light  border-10 p-2'>
        <Grid container className='p-2 mb-4 mt-3 align-items-center' gap={3}>
          <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
            <Typography className='fs-42 text-center'>Manage Cues</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 3, md: 3 }}>
            <Stack>
              <Box
                onClick={() => setOpen(true)}
                className='table-row-background link-btn'
              >
                Add New Cues
              </Box>
            </Stack>
          </Grid>
        </Grid>

        {Scenarios?.length > 0 ? (
          <Grid container spacing={2}>
          { Scenarios?.map((item: any) => (
            <Grid size={4} key={item?.scenarioId} className='border d-flex align-items-center p-2 border-main border-10'>
              <Box flex='1'>
                <Typography variant='h6' className='fw-bold'>{item?.scenarioName}</Typography>
              </Box>
              <Box className='d-flex align-items-center'>
                <IconButton className='mr-0' onClick={() => { setselectedScenario(item); setOpen(true) }}>
                  <Box component='img' height='32px' src={edit}></Box>
                </IconButton>
                <IconButton className='pl-0 ml-0' onClick={() => { handleDeleteStaff(item.scenarioId) }}>
                  <Box component='img' height='32px' src={deleteicon}></Box>
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>
        ): (<Typography variant='h6' className='text-center'>No Cues found</Typography>)}
      </Box>

      <Dialog open={open} className='p-2'>

        <DialogTitle className='m-0 mt-2 p-0' style={{ textAlign: "center" }}>
          {selectedScenario ? "Edit" : "Add"} Cues</DialogTitle>
        <DialogContent>
          <div className="form-group mb-0">
            <TextField
              label="Cues Name"
              fullWidth
              size="small"
              sx={{ marginTop: "10px", boxShadow: 'none' }}
              value={scenarioName || selectedScenario?.scenarioName}
              onChange={(e) => setscenarioName(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
          <Button
            variant="outlined"
            sx={{ color: '#75724C', borderColor: '#75724C', width: '100%' }}
            onClick={() => { setOpen(false); setscenarioName(""); setselectedScenario(null) }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            className='table-row-background'
            sx={{ width: '100%' }}

            onClick={() => {
              ScenarioStaff();
            }}
          >
            {selectedScenario ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default StoreScenarios
